export const getNoParamsCurrentUrl = () => window.location.href.split('?')[0]
